module.exports = __webpack_public_path__ + "static/media/explore-icon.9a14d1ac.svg";